import Images from "@Theme/Images";
import Styles from "./styles.module.scss";

export default function EmptyData({ label, type, customLabel = "" }) {
  return (
    <div className={Styles.emptyData}>
      <div className={Styles.emptyBox}>
        <div className={Styles.images}>
          <img src={Images.EMPTY_PAGEL} alt="" />
        </div>
        {customLabel ? (
          <span>{customLabel}</span>
        ) : (
          <span>
            Belum ada {type === "doc" ? "" : "Data"} {label} yang Ditambahkan
          </span>
        )}
      </div>
    </div>
  );
}
